import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { isIOSMobile } from '@/lib/platform'

export default function AppRedirectPage() {
  const navigate = useNavigate()

  useEffect(() => {
    if (isIOSMobile()) {
      window.location.href = 'https://apps.apple.com/fi/app/getmoretats/id6754553245'
    } else {
      navigate('/feed')
    }
  }, [navigate])

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground mx-auto mb-4"></div>
        <p className="text-foreground">Redirecting...</p>
      </div>
    </div>
  )
}

